import { render, staticRenderFns } from "./dataMaintenance.vue?vue&type=template&id=4452a8b0&scoped=true&"
import script from "./dataMaintenance.vue?vue&type=script&lang=js&"
export * from "./dataMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./dataMaintenance.vue?vue&type=style&index=0&id=4452a8b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4452a8b0",
  null
  
)

export default component.exports